package one.healthium.onboarding.domain.configs

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.domain.common.BMIRange

@Serializable
@SerialName("input_weight")
data class WeightInputScreenConfig(
    @SerialName("title") val title: String?,
    @SerialName("cta_title") val ctaTitle: String? = null,
    @SerialName("min_weight_kg") val minWeightKg: Int = 0,
    @SerialName("max_weight_kg") val maxWeightKg: Int = Int.MAX_VALUE,
    @SerialName("min_weight_lb") val minWeightLb: Int = 0,
    @SerialName("max_weight_lb") val maxWeightLb: Int = Int.MAX_VALUE,
    @SerialName("default_hint") val defaultHint: String? = null,
    @SerialName("underweight_bmi_title") val underweightBmiTitle: String? = null,
    @SerialName("underweight_bmi_text") val underweightBmiText: String? = null,
    @SerialName("normal_bmi_title") val normalBmiTitle: String? = null,
    @SerialName("normal_bmi_text") val normalBmiText: String? = null,
    @SerialName("overweight_bmi_title") val overweightBmiTitle: String? = null,
    @SerialName("overweight_bmi_text") val overweightBmiText: String? = null,
    @SerialName("obese_bmi_title") val obeseBmiTitle: String? = null,
    @SerialName("obese_bmi_text") val obeseBmiText: String? = null,
) : ScreenConfig {
    val bmiTitle = mapOf(
        BMIRange.Underweight to underweightBmiTitle,
        BMIRange.Normal to normalBmiTitle,
        BMIRange.Overweight to overweightBmiTitle,
        BMIRange.Obese to obeseBmiTitle,
    )
    val bmiText = mapOf(
        BMIRange.Underweight to underweightBmiText,
        BMIRange.Normal to normalBmiText,
        BMIRange.Overweight to overweightBmiText,
        BMIRange.Obese to obeseBmiText,
    )
}